/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CustomerDtoFromJSON, CustomerDtoToJSON, SortDirectionFromJSON, SortDirectionToJSON, } from './';
export function CustomerDtoSortedPagedListResponseFromJSON(json) {
    return CustomerDtoSortedPagedListResponseFromJSONTyped(json, false);
}
export function CustomerDtoSortedPagedListResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'pageNumber': !exists(json, 'pageNumber') ? undefined : json['pageNumber'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'total': !exists(json, 'total') ? undefined : json['total'],
        'sortPropertyName': !exists(json, 'sortPropertyName') ? undefined : json['sortPropertyName'],
        'sortDirection': !exists(json, 'sortDirection') ? undefined : SortDirectionFromJSON(json['sortDirection']),
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : json['items'].map(CustomerDtoFromJSON)),
    };
}
export function CustomerDtoSortedPagedListResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'pageNumber': value.pageNumber,
        'pageSize': value.pageSize,
        'total': value.total,
        'sortPropertyName': value.sortPropertyName,
        'sortDirection': SortDirectionToJSON(value.sortDirection),
        'items': value.items === undefined ? undefined : (value.items === null ? null : value.items.map(CustomerDtoToJSON)),
    };
}
